export default __webpack_public_path__ + "static/messages-section-messages-cdc8f9642a88c24867cfc2b6a051f2fb70936de2116d6b1c4d1d4409ea760248.png";